/* MIcase - REGLAS DE COMPORTAMIENTO DEL CAJON DEL CARRITO.
   Dos, y las dos salieron de un reporte de Sebastian con captura:
     1) cerrar el cajon no puede mover la pagina;
     2) mientras el cajon esta abierto, el pop-up de pagar no aparece.
   v1 y v2: 18 de agosto de 2026. La segunda regla se anadio de madrugada.

   ---- PRIMERA REGLA · CERRAR EL CAJON NO PUEDE MOVER LA PAGINA ----

   EL FALLO, reportado por Sebastian dos veces: abre el carrito con el chip de la barra de
   compra, toca fuera para cerrarlo y la ficha aparece arriba del todo en vez de quedarse
   donde estaba. Lo reporto tambien en el tema publicado.

   LA CAUSA DE FONDO, leida en assets/cart-drawer.js: close() llama
   removeTrapFocus(this.activeElement), y activeElement es #cart-icon-bubble, el icono del
   carrito del ENCABEZADO. removeTrapFocus (assets/global.js, linea 202) hace
   elementToFocus.focus() a secas, y enfocar un elemento que esta al principio del documento
   obliga al navegador a traerlo a la vista. Eso es el salto. No es un fallo del chip: el chip
   pulsa el icono real a proposito para no reimplementar la apertura (regla 20).

   POR QUE LA v1 NO LO ARREGLO. Envolvia cart-drawer.prototype.close y restauraba el scroll.
   Parecia correcto y no lo era, por una razon de orden de ejecucion:

     El constructor de CartDrawer hace
         this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
     y bind() CONGELA la funcion que close valia EN ESE INSTANTE.

   cart-drawer.js va en la cabecera y este archivo va en el cuerpo; los dos con defer, o sea
   que se ejecutan en orden de documento. Cuando este archivo envolvia el prototipo, el
   elemento <cart-drawer> YA se habia actualizado y el oyente de la capa oscura ya tenia
   guardada la close ORIGINAL, sin envolver. Resultado: cerrar con Escape o con la X pasaba
   por el envoltorio, pero TOCAR FUERA -que es justo lo que hace Sebastian- se lo saltaba.
   El arreglo funcionaba en todos los caminos menos en el unico que se usa.

   EL ARREGLO DE LA v2: se ataca el origen, no el camino. Se envuelven las funciones GLOBALES
   removeTrapFocus y trapFocus, que es donde de verdad ocurre el focus(). Se resuelven por
   nombre en el momento de la llamada -no estan capturadas por ningun bind-, asi que da igual
   quien las llame ni cuando: la capa oscura, la X, Escape, el menu movil o cualquier otro
   componente de Dawn.

   COMO SE ANULA EL SALTO: mientras corre la funcion original se sustituye
   HTMLElement.prototype.focus por una version que fuerza {preventScroll:true}. El foco se
   sigue moviendo -no se rompe la accesibilidad, que es para lo que existe removeTrapFocus-,
   lo unico que se anula es el desplazamiento que lo acompana. Se restaura en un finally, asi
   que ni un error dentro de la original puede dejar el prototipo parcheado.

   SE CONSERVA EL ENVOLTORIO DE close() como segunda red: si en algun navegador viejo
   preventScroll no existe, la restauracion de scroll sigue ahi para los caminos que si pasan
   por el prototipo.

   PROBADO EN banco/foco-test.mjs, que reproduce el orden real -constructor primero, este
   archivo despues- y comprueba seis cosas: que sin arreglo salta, que con la v1 SEGUIA
   saltando al tocar fuera, que con la v2 no salta, que el foco se sigue devolviendo, que el
   prototipo queda limpio al terminar y que cerrar por codigo tampoco salta.

   No toca el cajon en ningun otro sentido: ni como se abre, ni que pinta, ni cuando. */
(function () {
  if (window.MCcajonFoco) return;
  window.MCcajonFoco = true;

  /* Corre fn con el desplazamiento del foco desactivado. Sincrono a proposito: las dos
     funciones que envuelve lo son, y el prototipo se devuelve en el finally. */
  function sinSalto(fn, ctx, args) {
    var proto = window.HTMLElement && window.HTMLElement.prototype;
    if (!proto || typeof proto.focus !== 'function') return fn.apply(ctx, args);
    var original = proto.focus;
    proto.focus = function (opciones) {
      var o = {};
      if (opciones) for (var k in opciones) o[k] = opciones[k];
      o.preventScroll = true;
      try { return original.call(this, o); }
      catch (e) { return original.call(this); }
    };
    try { return fn.apply(ctx, args); }
    finally { proto.focus = original; }
  }

  function envuelveGlobal(nombre) {
    var fn = window[nombre];
    if (typeof fn !== 'function' || fn.mcSinSalto) return false;
    var nueva = function () { return sinSalto(fn, this, arguments); };
    nueva.mcSinSalto = true;
    try { window[nombre] = nueva; } catch (e) { return false; }
    return window[nombre] === nueva;
  }

  /* Segunda red: el envoltorio de close() de la v1. Solo cubre los caminos que resuelven
     close por el prototipo, pero no estorba y salva a los navegadores sin preventScroll. */
  function envuelveClase(clase) {
    if (!clase || !clase.prototype || clase.prototype.mcSinSalto) return;
    var cerrar = clase.prototype.close;
    if (typeof cerrar !== 'function') return;
    clase.prototype.close = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      var r = cerrar.apply(this, arguments);
      if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
      /* El guardia no es adorno: sin el, un entorno sin requestAnimationFrame -o un
         navegador muy viejo- lanzaria dentro de close() y dejaria el cajon a medio cerrar.
         Un arreglo de comodidad no puede romper el cierre del carrito. */
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          if (Math.abs((window.scrollY || 0) - y) > 1) window.scrollTo(0, y);
        });
      }
      return r;
    };
    clase.prototype.mcSinSalto = true;
  }

  /* =================================================================================
     SEGUNDA REGLA · MIENTRAS EL CAJON ESTE ABIERTO, EL POP-UP DE PAGAR NO APARECE.
     Reportado por Sebastian el 18 de agosto con captura: el pop-up "Tu Xiaomi todavia
     esta protegido a medias" salio ENCIMA del cajon abierto. Ahi no tiene sentido: quien
     tiene el cajon abierto ya esta en el camino de pagar, y taparle el boton de pagar con
     una invitacion a pagar es competir contra uno mismo.

     POR QUE NO SE ARREGLA EN micase-popups.js, QUE ES SU CASA. Pesa 58 KB y la API solo
     escribe archivos completos (regla 34): reenviar 58 KB para anadir una condicion es la
     operacion que ya trunco un archivo de 47 KB el 17 de agosto (regla 67). El riesgo no
     compensa cuando hay una puerta limpia desde fuera.

     LA PUERTA LIMPIA. La funcion intenta() de ese archivo empieza asi:
         if(abierto || disparado || yaVisto()) return;
     y yaVisto() NO es una variable cacheada: lee el almacenamiento CADA VEZ
     (micase-popups.js, linea 841). Y la clave y la frecuencia no estan escondidas: viajan
     en el JSON de #mcpg-cfg, que esta en el DOM.

     ASI QUE: mientras el cajon esta abierto se escribe esa marca, y al cerrarlo se borra.
     El pop-up se rinde solo, por su propio camino, sin parchear nada suyo.

     DOS CUIDADOS QUE NO SON OPCIONALES:
       · Si la marca YA existia -el cliente vio el pop-up antes de verdad- no se toca ni se
         borra al cerrar. Solo se deshace lo que se puso.
       · Si la frecuencia esta en "siempre", yaVisto() devuelve falso pase lo que pase y la
         marca no sirve. Para ese caso queda la segunda red: en cuanto #mcpg se hace
         visible con el cajon abierto, se vuelve a esconder.

     PROBADO EN banco/popup-cajon-test.mjs, cuatro escenarios: que abrir el cajon pone la
     marca, que cerrarlo la quita, que una marca legitima anterior NO se borra, y que con
     frecuencia "siempre" el pop-up se tapa igual y vuelve a poder salir con el cajon
     cerrado.
     ================================================================================= */
  var POP = (function () {
    var puesto = false;
    function cfg() {
      var n = document.getElementById('mcpg-cfg');
      if (!n) return null;
      try { return JSON.parse(n.textContent) } catch (e) { return null }
    }
    function memoria(c) {
      try { return c.frec === 'sesion' ? window.sessionStorage : window.localStorage }
      catch (e) { return null }
    }
    return {
      calla: function () {
        var c = cfg(); if (!c || !c.clave) return;
        var m = memoria(c); if (!m) return;
        try {
          if (m.getItem(c.clave) != null) return;   /* ya estaba visto de verdad */
          m.setItem(c.clave, String(Date.now()));
          puesto = true;
        } catch (e) {}
      },
      suelta: function () {
        if (!puesto) return;
        puesto = false;
        var c = cfg(); if (!c || !c.clave) return;
        var m = memoria(c); if (!m) return;
        try { m.removeItem(c.clave) } catch (e) {}
      },
      tapa: function () {
        var p = document.getElementById('mcpg');
        if (!p || p.hidden) return;
        try { p.classList.remove('mc-pop-on'); p.hidden = true } catch (e) {}
      }
    };
  })();

  var vigilando = false;
  function vigilaCajon() {
    if (vigilando) return;
    var dr = document.querySelector('cart-drawer');
    if (!dr || typeof MutationObserver !== 'function') return;
    vigilando = true;
    var antes = dr.classList.contains('active');
    if (antes) POP.calla();
    new MutationObserver(function () {
      var ahora = dr.classList.contains('active');
      if (ahora === antes) return;
      antes = ahora;
      if (ahora) POP.calla(); else POP.suelta();
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
    var pop = document.getElementById('mcpg');
    if (pop) {
      new MutationObserver(function () {
        if (dr.classList.contains('active')) POP.tapa();
      }).observe(pop, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
  }

  function intenta() {
    envuelveGlobal('removeTrapFocus');
    envuelveGlobal('trapFocus');
    if (window.customElements) envuelveClase(customElements.get('cart-drawer'));
    vigilaCajon();
  }

  intenta();
  /* Se reintenta porque global.js podria ejecutarse despues en algun montaje: una declaracion
     de funcion en el ambito global reescribiria la propiedad y se perderia el envoltorio. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', intenta);
  window.addEventListener('load', intenta);
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(intenta).catch(function () {});
  }
})();